<script lang="ts">
import { defineComponent, PropType } from "vue";
import KlereoIcon from "@/shared/components/KlereoIcon.vue";

export default defineComponent({
  components: { KlereoIcon },
  props: {
    loading: {
      required: true,
      type: Boolean,
    },
    error: {
      type: Object as PropType<any>,
      default: undefined,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
    },
  },
  data: function () {
    return {
      shown: this.loading,
    };
  },
  watch: {
    loading() {
      if (this.loading) {
        this.shown = true;
      } else {
        setTimeout(
          () => (this.shown = false),
          this.showIcon || this.error ? (this.error ? 3000 : 1000) : 250
        );
      }
    },
  },
});
</script>

<template>
  <div
    class="fixed inset-0 z-10 bg-black bg-opacity-75 z-10 p-10 flex items-center flex-col justify-center transition transition-opacity ease-in duration-300"
    :class="{ 'opacity-0 pointer-events-none': !shown }"
  >
    <div
      class="transition scale-100 duration-500"
      :class="{ 'scale-0': !shown }"
    >
      <div
        v-if="showIcon || error"
        class="bg-[rgba(255,255,255,0.3)] rounded-[50%]"
        style="backdrop-filter: blur(10px); transform: scale(0.3)"
      >
        <div class="loadingio-spinner-spinner-eenv5usbeha" v-if="loading">
          <div
            class="ldio-5scassuayna"
            style="transform: scale(1.2); transform-origin: center center"
          >
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div
          class="transition transition-100 transition-transform duration-300 ease-in-out"
          :class="loading ? 'scale-0 h-0' : 'scale-100'"
        >
          <klereo-icon
            v-if="!error"
            name="x-success"
            style="width: 275px; padding: 30px"
          />
          <klereo-icon
            v-if="error"
            name="x-error"
            style="width: 275px; padding: 30px"
          />
        </div>
      </div>
    </div>

    <div
      class="absolute text-red-300 text-center"
      style="top: calc(50% + 75px)"
    >
      {{ error?.message ?? error }}
    </div>

    <div
      v-if="!error"
      class="absolute text-bluenew text-center"
      style="top: calc(50% + 75px)"
    >
      {{ message }}
      <slot name="message" />
    </div>
  </div>
</template>

<style scoped>
@keyframes ldio-5scassuayna {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.ldio-5scassuayna div {
  left: 126.585px;
  top: 56.114999999999995px;
  position: absolute;
  animation: ldio-5scassuayna linear 1s infinite;
  background: #30add4;
  width: 9px;
  height: 33.93px;
  border-radius: 3.915px / 4.4109px;
  transform-origin: 3.915px 74.38499999999999px;
}
.ldio-5scassuayna div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -0.875s;
  background: #30add4;
}
.ldio-5scassuayna div:nth-child(2) {
  transform: rotate(45deg);
  animation-delay: -0.75s;
  background: #30add4;
}
.ldio-5scassuayna div:nth-child(3) {
  transform: rotate(90deg);
  animation-delay: -0.625s;
  background: #30add4;
}
.ldio-5scassuayna div:nth-child(4) {
  transform: rotate(135deg);
  animation-delay: -0.5s;
  background: #30add4;
}
.ldio-5scassuayna div:nth-child(5) {
  transform: rotate(180deg);
  animation-delay: -0.375s;
  background: #30add4;
}
.ldio-5scassuayna div:nth-child(6) {
  transform: rotate(225deg);
  animation-delay: -0.25s;
  background: #30add4;
}
.ldio-5scassuayna div:nth-child(7) {
  transform: rotate(270deg);
  animation-delay: -0.125s;
  background: #30add4;
}
.ldio-5scassuayna div:nth-child(8) {
  transform: rotate(315deg);
  animation-delay: 0s;
  background: #30add4;
}
.loadingio-spinner-spinner-eenv5usbeha {
  width: 261px;
  height: 261px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-5scassuayna {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-5scassuayna div {
  box-sizing: content-box;
}
/* generated by https://loading.io/ */
</style>
